import { ProtocolMode, ServerResponseType } from "@azure/msal-browser";
import { AppConstants } from "./../config/app-constants";
import { environment as base } from './environment.base';

export const environment = {
  ...base,
  production: true,
  baseUrl: '',
  version: '',
  msalConfig: {
    auth: {
      // 'Application (client) ID' of app registration API Connect Developer Portal or API Manager
      ...AppConstants.GetEnvAuth.CIAMConfig,
      protocolMode: ProtocolMode.OIDC,
      OIDCOptions: { "serverResponseType": ServerResponseType.FRAGMENT, "defaultScopes": ['openid'] },
      cloudDiscoveryMetadata: "",
      postLogoutRedirectUri: '/login',
      navigateToLoginRequestUrl: true,
      clientCapabilities: [],
      skipAuthorityMetadataCache: true,
      instanceDiscovery: false,
      instanceDiscoveryMetadata: ""
    },
    cache: {
      cacheLocation: "sessionStorage", // This configures where your cache will be stored
      storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
    },
  },
  apiConfig: { ...AppConstants.GetEnvAuth.apiConfig }
};